import { Text } from "@mantine/core";

import { format, parseISO } from "date-fns";

import { getCodeableConceptDisplay } from "@/utils/medplum";

import { ObservationDisplayProps } from "./interfaces";
import { ObservationQuantityDisplay } from "./ObservationQuantityDisplay";

export function ObservationValueDisplay({
  observation,
  showUnit = true,
  emptyText = "",
  ...others
}: ObservationDisplayProps) {
  if (!observation) {
    return <Text {...others}>{emptyText}</Text>;
  }
  if (typeof observation.valueQuantity !== "undefined") {
    return <ObservationQuantityDisplay showUnit={showUnit} observation={observation} {...others} />;
  }

  let value =
    observation.valueString ||
    observation.valueBoolean?.toString() ||
    observation.valueInteger?.toString() ||
    observation.valueCodeableConcept?.text ||
    getCodeableConceptDisplay(observation.valueCodeableConcept);

  if (typeof observation.valueDateTime !== "undefined") {
    const parsedValue = parseISO(observation.valueDateTime);
    // If it's a ISO formatted datetime, format as US datetime.
    // If not, format as US date
    if (observation.valueDateTime.length > "2024-12-31".length) {
      value = format(parsedValue, "MM/dd/yy h:mm a");
    } else {
      value = format(parsedValue, "MM/dd/yy");
    }
  }

  return <Text {...others}>{value}</Text>;
}
